import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const setSavingWorkingProjectErrorReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<Record<string, string | null>>) => {
    for (const [key, value] of Object.entries(action.payload)) {
      if (value === null) {
        delete state.savingWorkingProjectError[key];
      } else {
        state.savingWorkingProjectError[key] = value;
      }
    }

    state.saveId = null;
    state.refetchProjectAfterSave = false;
  });
};

export default setSavingWorkingProjectErrorReducer;
